import dental from "../assets/Specialties/Dental_Billing_icon.png";
import Internal from "../assets/Specialties/Internal_Medicine.png";
import Ophthalmology from "../assets/Specialties/Ophthalmology.png";
import lab from "../assets/Specialties/Lab_Billing.png";
import Cardiology from "../assets/Specialties/Medical_Service_Icons_Cardiology.png";
import MentalHealth from "../assets/Specialties/mentalhealth.png";
import Cardiovascular from "../assets/Specialties/Medical_Service_Icons_Cardiovescular.png";
import DME from "../assets/Specialties/Medical_Service_Icons_DME.png";
import Dermatologist from "../assets/Specialties/Medical_Service_Icons_Dermattology.png";
import Hematology from "../assets/Specialties/Medical_Service_Icons_Hematology.png";
import Ambulatory from "../assets/Specialties/Medical_Service_Icons_Ambulatory_Surgery.png";
import Gynecology from "../assets/Specialties/Medical_Service_Icons_Gynecology.png";
import Geriatrics from "../assets/Specialties/Medical_Service_Icons_Geriatrics.png";
import General from "../assets/Specialties/Medical_Service_Icons_General_Surgery.png";
import Gastroenterology from "../assets/Specialties/Medical_Service_Icons_Gastroenterology.png";
import FQHC from "../assets/Specialties/Medical_Service_Icons_FQHC.png";
import Endocrinology from "../assets/Specialties/Medical_Service_Icons_Endocrinology.png";
import Pathology from "../assets/Specialties/Medical_Service_Icons_Pathology_Lab.png";
import Oncology from "../assets/Specialties/Medical_Service_Icons_Oncology.png";
import OBGYN from "../assets/Specialties/Medical_Service_Icons_OB_GYN.png";
import Molecular from "../assets/Specialties/Medical_Service_Icons_Molecular_Lab.png";
import home from "../assets/Specialties/Medical_Service_Icons_Home_Nursing.png";
import Hepatology from "../assets/Specialties/Medical_Service_Icons_Hepatology.png";
import Psychiatric from "../assets/Specialties/Medical_Service_Icons_Psychiatric.png";
import Prostheses from "../assets/Specialties/Medical_Service_Icons_Prostheses.png";
import Primary from "../assets/Specialties/Medical_Service_Icons_Primary Care.png";
import Podiatry from "../assets/Specialties/Medical_Service_Icons_Podiatry.png";
import Physical from "../assets/Specialties/Medical_Service_Icons_Physical_Therapy.png";
import Pediatric from "../assets/Specialties/Medical_Service_Icons_Pediatric.png";
import Wound from "../assets/Specialties/Medical_Service_Icons_Wound_Care.png";
import Traumatology from "../assets/Specialties/Medical_Service_Icons_Traumatology.png";
import Thoracic from "../assets/Specialties/Medical_Service_Icons_Thoracic_Surgery.png";
import Rheumatology from "../assets/Specialties/Medical_Service_Icons_Rheumatology.png";
import Pulmonology from "../assets/Specialties/Medical_Service_Icons_Pulmonology.png";
import Psychology from "../assets/Specialties/Medical_Service_Icons_Psychology.png";
import Medical from "../assets/Specialties/Medical_Service_Icons_Medial_Clinics.png";
import Urology from "../assets/Specialties/Medical_Service_Icons_Urology.png";
import Toxicology from "../assets/Specialties/Medical_Service_Icons_Toxicology_Lab.png";
import Rehab from "../assets/Specialties/Medical_Service_Icons_Substance_Abuse Rehab.png";
import Radiology from "../assets/Specialties/Medical_Service_Icons_Radiology.png";
import Pain from "../assets/Specialties/Medical_Service_Icons_Pain_Management.png";
import Neurosugery from "../assets/Specialties/Medical_Service_Icons_Neurosugery.png";
import Nephrology from "../assets/Specialties/Medical_Service_Icons_Nephrology.png";
import Infectious from "../assets/Specialties/Medical_Service_Icons_Infectious_Disease.png";
import Immunology from "../assets/Specialties/Medical_Service_Icons_Immunology.png";
import Plasticsurgery from "../assets/Specialties/plastic-surgery.png";
import Otolaryngology from "../assets/Specialties/Ophthalmology.png";

export const OurSpecialtiesMenu = [
  {
    id: "1",
    name: "Dental Billing",
    image: dental,
    title:
      "UMS offers dental billing services, comprehending codes (CPT, ICD-10) for dental procedures. Our expertise ensures accurate coding, efficient billing, and streamlined revenue management for dental practices.",
  },
  {
    id: "2",
    name: "Internal Medicine",
    image: Internal,
    title:
      "UMS' medical billing experts excel in navigating complex medical claims for adult patients. They ensure accurate coding, efficient reimbursement processes, and compliance adherence, ensuring seamless financial operations for internal medicine practices",
  },
  {
    id: "3",
    name: "Neurology",
    image: Neurosugery,
    title:
      "Provide neurology medical billing services, comprehending codes (CPT 95800-95999, ICD-10 G00-G99) for procedures like EEG, nerve conduction studies, and neurological disorder treatments, ensuring precise billing and documentation.",
  },
  {
    id: "4",
    name: "Mental Health",
    image: MentalHealth,
    title:
      "UMS offers efficient revenue cycle management for mental health services. Our precise coding with CPT codes 90791 (Psychiatric diagnostic evaluation) and 90837 (Psychotherapy) maximizes reimbursements and streamlines financial processes.",
  },
  {
    id: "5",
    name: "Dermatologist",
    image: Dermatologist,
    title:
      "In the realm of dermatology, we utilize error-free codes (e.g., CPT 99212 for office visits, and ICD-10 L82 for seborrheic keratosis) to diagnose and treat skin conditions effectively. Embracing cryotherapy and topical medications ensures healthier skin.",
  },
  {
    id: "6",
    name: "Orthopedics",
    image: Podiatry,
    title:
      "UMS offers specialized Orthopedics medical billing, utilizing specific CPT codes (e.g., 27447 for total knee replacement) and ICD-10 codes (e.g., M17.9 for osteoarthritis of the knee) to ensure accurate billing and documentation for musculoskeletal treatments.",
  },
  {
    id: "7",
    name: "Lab Billing",
    image: lab,
    title:
      "UMS offers lab billing services with detailed CPT and ICD-10 coding. They handle billing for lab tests, diagnostic services, and pathology, ensuring streamlined processes and optimized reimbursement for healthcare facilities.",
  },
  {
    id: "8",
    name: "General Surgery",
    image: General,
    title:
      "UMS provides billing services for general surgery, using detailed coding (CPT 10021-69990, ICD-10 0-9) for various procedures, ensuring a comprehensive and transparent billing process, optimizing reimbursement, and streamlining the revenue cycle for general surgery services.",
  },
  {
    id: "9",
    name: "Plastic Surgery",
    image: Plasticsurgery,
    title:
      "Plastic surgery encompasses cosmetic, reconstructive, and hand surgery. UMS ensures accurate coding and claims submission for procedures using CPT codes (e.g., 15830, 19318) and ICD-10 codes (e.g., Z41.1, L76.81).",
  },
  {
    id: "10",
    name: "Otolaryngology",
    image: Otolaryngology,
    title:
      "Expert ENT medical billing with CPT codes 31231 (Nasal endoscopy) and 69210 (Ear wax removal). Specializing in rhinology, laryngology, pediatric ENT, head, and neck surgery. Optimize revenue through efficient financial management.",
  },
  {
    id: "11",
    name: "Gynecology",
    image: Gynecology,
    title:
      "UMS specializes in Gynecology medical billing, using accurate CPT and ICD-10 coding for pelvic exams, pap smears, ultrasounds, colposcopies, and contraceptive counseling, ensuring comprehensive documentation of gynecological healthcare procedures.",
  },
  {
    id: "12",
    name: "Geriatrics",
    image: Geriatrics,
    title:
      "We specialize in medical coding and reimbursement for geriatrics, ensuring accurate CPT and ICD-10 coding for comprehensive assessments, disease management, and medication reconciliation to meet elderly patients' healthcare needs.",
  },
  {
    id: "13",
    name: "Ophthalmology",
    image: Ophthalmology,
    title:
      "We provide specialized medical billing for eye care practices, utilizing CPT codes like 92014 (comprehensive eye exams) and ICD-10 codes like H25.9 (age-related cataract) to ensure accurate billing and documentation for procedures and diagnoses",
  },
  {
    id: "14",
    name: "Gastroenterology",
    image: Gastroenterology,
    title:
      "UMS offers billing services for Gastroenterology, utilizing specific coding (CPT 45378-45398, ICD-10 K00-K95) for procedures like endoscopy, colonoscopy, and digestive disorder treatments, ensuring efficient billing and accurate documentation.",
  },
  {
    id: "15",
    name: "Cardiology",
    image: Cardiology,
    title:
      "Efficiently manage various aspects of cardiology, utilizing accurate CPT and ICD-10 codes for diagnosis and treatment. Our interventions, like angioplasty and medication, ensure optimal cardiovascular health.",
  },
  {
    id: "16",
    name: "Endocrinology",
    image: Endocrinology,
    title:
      "Accurate coding is paramount in endocrinology medical billing, encompassing services such as hormone testing, diabetes management, thyroid disorders, and metabolic evaluations. This ensures proper documentation and facilitates appropriate reimbursement for endocrine-related healthcare procedures",
  },
  {
    id: "17",
    name: "Ambulatory",
    image: Ambulatory,
    title:
      "Ambulatory medical billing involves assigning standardized CPT codes for procedures and ICD-10 codes for diagnoses, ensuring accurate documentation and reimbursement in outpatient healthcare settings.",
  },
  {
    id: "18",
    name: "Oncology",
    image: Oncology,
    title:
      "In the realm of oncology, accurate coding (CPT and ICD-10) plays a vital role in services like chemotherapy administration, radiation therapy, tumor biopsies, and palliative care, ensuring proper documentation and reimbursement.",
  },
  {
    id: "19",
    name: "OBGYN",
    image: OBGYN,
    title:
      "UMS experts specialize in OBGYN medical billing, providing accurate CPT and ICD-10 coding for prenatal care, childbirth, pap smears, ultrasounds, and fertility treatments, ensuring proper documentation and reimbursement for women's healthcare.",
  },
  {
    id: "20",
    name: "Hematology",
    image: Hematology,
    title:
      "We are specialized in medical billing for Hematology, utilizing specific codes (CPT and ICD-10) for blood disorder diagnosis and treatment services. Accurate coding ensures proper reimbursement for healthcare procedures in hematology.",
  },
  {
    id: "21",
    name: "Home Nursing",
    image: home,
    title:
      "We specialize in home nursing coding for medical billing, using error-free CPT and ICD-10 codes to document services like wound care, medication management, and skilled nursing visits, ensuring accurate billing and reimbursement.",
  },
  {
    id: "22",
    name: "Hepatology",
    image: Hepatology,
    title:
      "UMS provides hepatology coding for medical billing with accurate CPT and ICD-10 codes. Services include liver function tests, viral hepatitis management, and liver disease treatments, ensuring accurate documentation and reimbursement.",
  },
  {
    id: "23",
    name: "Psychiatric",
    image: Psychiatric,
    title:
      "UMS offers psychiatric billing services with detailed coding (CPT 90785, 90832-90853, ICD-10 F01-F99) for mental health evaluations, therapy sessions, and psychiatric treatment, ensuring a clear and accurate billing process for psychiatric services.",
  },
  {
    id: "24",
    name: "Prostheses",
    image: Prostheses,
    title:
      "UMS offers billing services for prostheses with precise coding (CPT L5000-L5999, ICD-10 Z44-Z46) for fitting, procurement, and maintenance of prosthetic devices, ensuring a clear and efficient billing process for prosthetic services.",
  },
  {
    id: "25",
    name: "Primary Care",
    image: Primary,
    title:
      "Use error-free codes (CPT and ICD-10) for check-ups, vaccinations, disease management, and preventive care. Their expertise ensures efficient billing, compliance with regulations, and improved revenue management.",
  },
  { id: "26", name: "DME", image: DME },
  {
    id: "27",
    name: "Physical Therapy",
    image: Physical,
    title:
      "Physical therapy medical billing utilizes CPT codes for therapy evaluations (97161-97168) and therapeutic procedures (97110-97124, 97140, and 97530) with ICD-10 codes for precise diagnoses, ensuring effective management and optimal revenue generation.",
  },
  {
    id: "28",
    name: "Pediatric",
    image: Pediatric,
    title:
      "We excel in Pediatric medical billing, employing accurate CPT and ICD-10 coding for specialized healthcare services to infants, children, and adolescents. Our expertise ensures proper documentation and optimized revenue cycles.",
  },
  {
    id: "29",
    name: "Wound Care",
    image: Wound,
    title:
      "Our highly skilled team specializes in Wound Care medical billing, utilizing precise CPT and ICD-10 coding for specialized treatments and dressings. We optimize documentation and ensure appropriate reimbursement for wound management procedures.",
  },
  {
    id: "30",
    name: "Traumatology",
    image: Traumatology,
    title:
      "UMS provides traumatology billing services with detailed coding (CPT 20000-29999, ICD-10 S00-T98) for trauma-related procedures, ensuring transparent billing processes and accurate documentation for trauma treatments.",
  },
  // { id: "31", name: "Thoracic Surgery", image: Thoracic },
  {
    id: "31",
    name: "Rheumatology",
    image: Rheumatology,
    title:
      "UMS provides rheumatology billing services with precise coding (CPT 71450-71460, ICD-10 M05-M14) for procedures like joint injections, imaging, and arthritis management, ensuring transparent billing and accurate documentation for rheumatological treatments.",
  },
  {
    id: "32",
    name: "Pulmonology",
    image: Pulmonology,
    title:
      "In Pulmonology medical billing, we specialize in accurate CPT and ICD-10 coding for respiratory treatments, diagnostic tests, and lung disease management. Our focus ensures comprehensive documentation and efficient reimbursement processes.",
  },
  {
    id: "33",
    name: "Psychology",
    image: Psychology,
    title:
      "UMS provides Psychology medical billing services, utilizing specific codes like DSM (Diagnostic and Statistical Manual of Mental Disorders) codes for mental health diagnoses, ensuring accurate documentation and streamlined billing processes.",
  },
  {
    id: "34",
    name: "Medical Clinics",
    image: Medical,
    title:
      "Medical clinics offering medical billing services specialize in accurate coding (CPT and ICD-10) for diverse healthcare treatments, ensuring efficient documentation and optimized reimbursement for various medical procedures.",
  },
  {
    id: "35",
    name: "Urology",
    image: Urology,
    title:
      "Our specialty in Urology medical billing services involves decoding CPT and ICD-10 codes for urological procedures, ensuring accurate documentation, and timely payment and reimbursement processes for urology practices.",
  },
  // { id: "37", name: "Toxicology Lab", image: Toxicology },
  {
    id: "36",
    name: "Rehab",
    image: Rehab,
    title:
      "UMS specializes in medical billing for rehab services, ensuring accurate coding (CPT and ICD-10) for therapies like physical therapy, occupational therapy, and speech therapy, and ensuring proper documentation and reimbursement.",
  },
  {
    id: "37",
    name: "Radiology",
    image: Radiology,
    title:
      "Our specialty lies in Radiology medical billing services, employing detailed coding (CPT 70010-79999, ICD-10-PCS) for imaging procedures such as X-rays, CT scans, and MRIs. This ensures precise documentation and optimal reimbursement for radiological services.",
  },
  {
    id: "38",
    name: "Pain Management",
    image: Pain,
    title:
      "UMS specializes in Pain Management medical billing, utilizing specific CPT codes (00100-01999) and ICD-10 codes (G89.00-G89.4) for precise documentation and reimbursement of procedures like nerve blocks, epidurals, and pain assessments.",
  },
  {
    id: "39",
    name: "Cardiovascular",
    image: Cardiovascular,
    title:
      "UMS specializes in Cardiovascular medical billing, utilizing error-free coding (CPT 92920-93799, ICD-10 I00-I99) for procedures like cardiac catheterization, angioplasty, and echocardiography. This ensures accurate documentation and optimal reimbursement for cardiovascular treatments.",
  },
  {
    id: "40",
    name: "Nephrology",
    image: Nephrology,
    title:
      "We specialize in Nephrology medical billing, using specific coding (CPT 90935-90999, ICD-10 N00-N29) for procedures like dialysis, kidney biopsies, and renal disease management. This ensures accurate documentation and proper reimbursement for nephrology treatments.",
  },
  {
    id: "41",
    name: "Infectious Disease",
    image: Infectious,
    title:
      "UMS provides Infectious Disease medical billing services, utilizing detailed coding (CPT 99201-99499, ICD-10 A00-B99) for consultations, diagnostic tests, and treatment management. This ensures accurate documentation and optimized reimbursement for infectious disease treatments.",
  },
  {
    id: "42",
    name: "Immunology",
    image: Immunology,
    title:
      "UMS offers medical billing services in Immunology, utilizing precise coding (CPT 95115-95199, ICD-10 D80-D89) for allergy testing, immunotherapy, and immune disorder management. This ensures accurate documentation and optimal reimbursement for immunological treatments.",
  },
];
